// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divBox.relative[data-v-b4c137b4] {\n  position: relative;\n}\n.divBox .mt14[data-v-b4c137b4] {\n  margin-top: 14px;\n}\n.divBox .selWidth[data-v-b4c137b4] {\n  width: 200px;\n}\n.divBox .padding-add[data-v-b4c137b4] {\n  padding: 20px;\n}", ""]);
// Exports
module.exports = exports;
